import { IMusicProductDigitalAlbum } from "services/music-product-digital/types/form";
import { IMusicProductDigitalTrackResponse } from "services/music-product-digital/types/query";

interface ITracks {
  [key: number]: IMusicProductDigitalAlbum;
}

export const convertTracksToAlbumsForm = (
  musicProductDigitalTracks: IMusicProductDigitalTrackResponse[]
) =>
  Object.values(
    musicProductDigitalTracks.reduce<ITracks>((acc, album) => {
      if (!acc[album.albumNumber]) {
        acc[album.albumNumber] = { albumNumber: album.albumNumber, tracks: [] };
      }
      acc[album.albumNumber].tracks.push({
        id: album.trackId,
        name: album.title,
        isrc: album.isrc,
        mp3Link: album.mp3Link,
        mp3PreviewLink: album.mp3PreviewLink,
        wavLink: album.wavLink,
        flacLink: album.flacLink,
      });
      return acc;
    }, {})
  );
